import { z } from 'zod';
import { EntitySchema } from './shared.schema';

/**
 * Codex entry schema.
 * A "grab bag" for worldbuilding elements like magic systems, history, artifacts, etc.
 */
export const CodexSchema = EntitySchema.extend({
  type: z.string().describe('User-defined category (e.g., Magic Rule, History, Artifact)'),
  content: z.string().optional().describe('Main markdown content of the entry'),
  tags: z.array(z.string()).default([]).describe('Searchable tags'),
});

export type Codex = z.infer<typeof CodexSchema>;
